import { useEffect, useState } from "react";

import { MySpinner } from "components/MySpinner";
import { StockTable } from "features/Stock/StockTable";
import { getStock } from "services/apiWarehouse";

import "./stock.scss";

export const Stock = ({ id, activeTab }) => {
  const [loading, setLoading] = useState(false);
  const [stock, setStock] = useState([]);

  const getAndSetStock = () => {
    setLoading(true);
    getStock({
      nomenclature: id
    })
      .then((res) => {
        setStock(res.stock || []);
        // setBalanceByDocuments(res.balanceByDocuments || []);
        // setBalanceByWarehouse(res.balanceByWarehouse || []);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (id) {
      getAndSetStock();
    }
  }, [id]);

  return (
    <div className="stock">
      {loading && <MySpinner overlay />}
      <StockTable
        stock={stock}
        nomenclature={id}
        getAndSetStock={getAndSetStock}
      />
    </div>

  );
}